import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom'
import ForecastContent from './ForecastContent'
import PastGraph from './PastGraph'
import PastContent from './PastContent'
import { useTime } from '../contexts/TimeContext'

function CurrentContent(props) {
  // 要素の取得
  const tabItem = document.querySelectorAll(".tab-item");
  const tabContent = document.querySelectorAll(".tab-content");

  // tabItemに対してクリックイベントを追加
  // クリックした時にtabToggle関数を発火
  for (let i = 0; i < tabItem.length; i++) {
    tabItem[i].addEventListener("click", tabToggle);
  }

  function tabToggle() {
    // tabItemとtabContentの.activeを削除する
    for (let i = 0; i < tabItem.length; i++) {
      tabItem[i].classList.remove("active");
    }
    for (let i = 0; i < tabContent.length; i++) {
      tabContent[i].classList.remove("active");
    }

    // クリックしたtabItemに.activeを追加
    this.classList.add("active");

    // tabItemを配列にする
    // [<li class="tab-item active">About</li>, <li class="tab-item">Works</li>, <li class="tab-item">Contact</li>]
    const aryTabs = Array.prototype.slice.call(tabItem);

    // 配列に格納したキーワードと最初一致したインデックスを格納
    // <li class="tab-item active">About</li>の場合は「0」が返ってくる
    const index = aryTabs.indexOf(this);

    // インデックスに対応したtabContentに.activeを追加
    tabContent[index].classList.add("active");
  }


  const { id } = useParams();
  const [subname, setSubname] = useState([])
  const [image, setImage] = useState([])
  const [card, setCard] = useState([])
  const [lastFetched, setLastFetched] = useState(null)

  const { displayTime } = useTime();

  useEffect(() => {
    axios.get(`/api/places/${id}`)
      .then(res => {
        setSubname(res.data.subname)
        setLastFetched(null)
      })
  }, [id,])

  useEffect(() => {
    if (subname.length === 0) return;
    const hour = displayTime.getHours().toString().padStart(2, '0');
    const minute = displayTime.getMinutes().toString().padStart(2, '0');
    const second = displayTime.getSeconds().toString().padStart(2, '0');
    const hhmmss = `${hour}${minute}${second}`
    axios.get(`/api/image/realtime/${subname}/${hhmmss}`, {responseType: 'blob',})
      .then(res => {
        if (res.data != null) {
          setImage([URL.createObjectURL(res.data)])
        }
        setLastFetched(Date())
      })
      .catch(() => {
        setLastFetched(Date())
      })
  }, [displayTime])

  useEffect(() => {
    if (subname.length === 0) return;
    setTimeout(() => {
      axios.get(`/api/weathernews/${id}`)
        .then(res => {
          setCard(res.data)
        })
    }, lastFetched === null ? 0 : 3600000)
  })

  return (
    <React.Fragment>
      <link rel="stylesheet" href="/css/detail.css" />
      <main>
        <section>
          <div class="ly_inner">
              <div class="bl_mapTop_inner">
                  <div class="bl_map_btn">
                      <div class="el_map_top">
                          <a href="/">
                              <p>▷TOPページ</p>
                          </a>
                      </div>
                      <div class="el_map_btn">
                          <button onclick="location.href='/map.html'">
                              <Link to={`/map`}>
                                  <img src="/img/maoBtn.png" alt="" />
                              </Link>
                          </button>
                      </div>
                  </div>
              </div>
            <div class="bl_ttlInner">
              <div class="bl_sectionTitle">
                <div class="el_sectionTitle_logo">
                  <img src="/img/point_logo_black.png" alt="" />
                </div>
                <div class="el_sectionTitle_name">
                  <h2>{subname}</h2>
                </div>
              </div>
            </div>
            <div class="bl_listInner">


              <ul class="tab-list">

                <li class="tab-item active">
                  <div class="bl_itemInner">

                    <div class="el_btnIcon">
                      <img src="/img/now_btn.png" alt="" />
                    </div>
                    <div class="el_btnTtl">
                      <p>現在の情報</p>
                    </div>
                  </div>
                </li>

                <li class="tab-item">
                  <div class="bl_itemInner">
                    <div class="el_btnIcon">
                      <img src="/img/past_btn.png" alt="" />
                    </div>
                    <div class="el_btnTtl">
                      <p>過去の情報</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="bl_containerInner">
              <div class="tab-container">
                <div class="tab-content active">
                  <div class="bl_contentInner">
                    <div class="bl_innerNow">
                      <div class="bl_video">
                        <div class="el_videoInner">
                          <img src={image} alt="" />
                        </div>
                      </div>

                      <div class="bl_info">
                        <div class="bl_infoInner">

                          <div class="bl_infoItem">
                            <div class="el_itemLogo">
                              <img src="/img/temp_color.jpg" alt="" />
                            </div>

                            <div class="el_itemInfo">
                              <p>{card.temp}℃</p>
                            </div>
                          </div>

                          <div class="bl_infoItem">
                            <div class="el_itemLogo">
                              <img src="/img/weather_color.jpg" alt="" />
                            </div>

                            <div class="el_itemInfo">
                              <p>{card.wx_name}</p>
                            </div>
                          </div>

                          <div class="bl_infoItem">
                            <div class="el_itemLogo">
                              <img src="/img/windspeed_color.jpg" alt="" />
                            </div>

                            <div class="el_itemInfo">
                              <p>風速 : {card.wndspd}m/s</p>
                            </div>
                          </div>

                          <div class="bl_infoItem bl_winddirection">
                            <div class="el_itemLogo">
                              <img src="/img/winddirection_color.jpg" alt="" />
                            </div>

                            <div class="el_itemInfo">
                              <p>風向 : {card.wnddir_name}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ForecastContent id={id}/>
                  </div>
                </div>
                <div class="tab-content">
                  <div class="bl_contentInner">
                    <div class="bl_innerNow">
                      <PastContent id={id} place={subname}/>
                      <div class="bl_pastWeather">
                        <div class="bl_pastWeather_ttl">
                          <div class="el_pastWeather_logo">
                            <img src="/img/weather_logo.png" alt="" />
                          </div>
                          <div class="el_pastWeather_name">
                            <p>過去天候情報</p>
                          </div>
                        </div>
                      </div>
                      <div class="bl_pastInfo">
                        <div class="el_pastInfo_inner">
                          <PastGraph id={id} place={subname}/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  )
}

export default CurrentContent
